//import fetchInst from "@/libs/fetch";
import axiosInst from "@/libs/axios";
import Cookies from 'js-cookie';

const USER_STORAGE_KEY = 'ec-checkout-user';
const USER_ADDRESS_STORAGE_KEY = 'ec-checkout-user-address';

const readFromStorage = (key, fallback) => {
    if (typeof localStorage === 'undefined') return fallback;
    try {
        const stored = localStorage.getItem(key);
        return stored ? JSON.parse(stored) : fallback;
    } catch (error) {
        return fallback;
    }
};

const writeToStorage = (key, value) => {
    if (typeof localStorage === 'undefined') return;
    try {
        if (!value || (typeof value === 'object' && Object.keys(value).length === 0)) {
            localStorage.removeItem(key);
            return;
        }
        localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        // ignore persist errors
    }
};

const buildIdempotencyKey = (prefix = 'mp') =>
    `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;

const resolvePagPlatform = (platformPath = '') => {
    const platform = platformPath.toString().toLowerCase();
    if (platform.includes('pagback')) return 'pagback';
    if (platform.includes('pagseguro')) return 'pagseguro';
    return 'pagbank';
};

const buildPagbankLinkPath = (data = {}, suffix = '') => {
    const storeRaw = data.storeNick
        || data.store_nick
        || data.store
        || data.storeNickname
        || null;
    const linkRaw = data.linkUuid
        || data.checkoutId
        || data.code_pay
        || data.uuid;
    const customerRaw = data.customerId || data.customer_id;
    if (!storeRaw || !linkRaw || !customerRaw) return null;
    const storeNick = encodeURIComponent(storeRaw.toString().trim());
    const linkUuid = encodeURIComponent(linkRaw);
    const customerId = encodeURIComponent(customerRaw);
    const platform = resolvePagPlatform(data.platformPath || '');
    const suffixPath = suffix ? `/${suffix}` : '';
    return `/stores/${storeNick}/payment/link/${linkUuid}/customer/${customerId}/${platform}${suffixPath}`;
};

const checkout = {
    modules: {
    },
    state: {
        stageCheckout: 1,
        linkCheckoutDetail: null,
        linkCheckoutUser: readFromStorage(USER_STORAGE_KEY, {
            id: null,
            fullName: "",
            email: "",
            phone_number: "",
            itin_number: "",
            has_account: null,
        }),
        linkCheckoutUserAddress: readFromStorage(USER_ADDRESS_STORAGE_KEY, {
            street: "",
            city: "",
            district: "",
            state: "",
            number: "",
            zip_code: "",
            country: "",
            complement: null,
        }),
    },
    getters: {
        returnLinkCheckoutDetail: state => state.linkCheckoutDetail,
        returnLinkCheckoutUser: state => state.linkCheckoutUser,
        returnLinkCheckoutUserAddress: state => state.linkCheckoutUserAddress,
        returnStageCheckout: state => state.stageCheckout,
    },
    actions: {
        getLinkDetails: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                const accessLink = Cookies.get(data.linkId);
                let outhersParams = ''
                if (accessLink) {
                    outhersParams = outhersParams + `?statistics=not`
                }
                await axiosInst.get(`/stores/psiqueasy/payment/link/${data.linkId}${outhersParams}`)
                    .then(response => {
                        commit('UPDATE_LINK_DETAILS', response.data);
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error.response)
                    });
            });
        },
        postCheckRegisteredUser: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                await axiosInst.post(`/stores/psiqueasy/payment/link/${data.linkId}/customer`, data)
                    .then(response => {
                        commit('UPDATE_USER_CHECKOUT', response.data);
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error.response)
                    });
            });
        },
        postCheckRegisteredUserAddress: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                await axiosInst.post(`/stores/psiqueasy/payment/link/${data.linkId}/customer/${data.customerId}/address`, data)
                    .then(response => {
                        commit('UPDATE_USER_ADDRESS_CHECKOUT', response.data);
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error.response)
                    });
            });
        },
        getDetaillCepAddress: ({ commit }, zip_Code) => {
            return new Promise(async (resolve, reject) => {

                await fetch(`https://viacep.com.br/ws/${zip_Code}/json/`).then(response => {
                    resolve(response.json())
                }).catch(error => {
                    reject(error.response)
                })
            })
        },
        getPaymentLink: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                await axiosInst.get(`/stores/psiqueasy/payment/link/${data.linkId}/customer/${data.customerId}/purchase`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error.response)
                    });
            });
        },
        getPaymentLinkStatus: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                await axiosInst.get(`/stores/psiqueasy/payment/link/${data.linkId}/payment/${data.linkUuidInco}/status`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error.response)
                    });
            });
        },
        getStoreContacts: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                await axiosInst.get(`/stores/psiqueasy/contacts`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error.response)
                    });
            });
        },
        postPaymentCard: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                const idem = data?.idempotencyKey || buildIdempotencyKey('mp-card');
                // DEBUG: log payload and warn if external_reference não parece um icopl-*
                try {
                    console.debug('[checkout][postPaymentCard] payload', data);
                    if (!data?.external_reference || !String(data.external_reference).startsWith('icopl-')) {
                        console.warn('[checkout][postPaymentCard] external_reference ausente ou não inicia com icopl-:', data?.external_reference);
                    }
                } catch (e) { /* noop */ }

                await axiosInst.post(`/customer/checkout/${data.checkoutId}/mercado-pago/payments/card`, data, {
                    headers: { 'X-Idempotency-Key': idem },
                })
                    .then(response => {
                        console.debug('[checkout][postPaymentCard] response', response?.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error('[checkout][postPaymentCard] error', error?.response?.data || error?.message || error);
                        reject(error.response);
                    });
            });
        },
        postPaymentPix: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                const idem = data?.idempotencyKey || buildIdempotencyKey('mp-pix');
                // DEBUG: log payload and warn if external_reference não parece um icopl-*
                try {
                    console.debug('[checkout][postPaymentPix] payload', data);
                    if (!data?.external_reference || !String(data.external_reference).startsWith('icopl-')) {
                        console.warn('[checkout][postPaymentPix] external_reference ausente ou não inicia com icopl-:', data?.external_reference);
                    }
                } catch (e) { /* noop */ }

                await axiosInst.post(`/customer/checkout/${data.checkoutId}/mercado-pago/payments/pix`, data, {
                    headers: { 'X-Idempotency-Key': idem },
                })
                    .then(response => {
                        console.debug('[checkout][postPaymentPix] response', response?.data);
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.error('[checkout][postPaymentPix] error', error?.response?.data || error?.message || error);
                        reject(error.response)
                    });
            });
        },
        postPaymentBol: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                const idem = data?.idempotencyKey || buildIdempotencyKey('mp-boleto');
                // DEBUG: log payload and warn if external_reference não parece um icopl-*
                try {
                    console.debug('[checkout][postPaymentBol] payload', data);
                    if (!data?.external_reference || !String(data.external_reference).startsWith('icopl-')) {
                        console.warn('[checkout][postPaymentBol] external_reference ausente ou não inicia com icopl-:', data?.external_reference);
                    }
                } catch (e) { /* noop */ }

                await axiosInst.post(`/customer/checkout/${data.checkoutId}/mercado-pago/payments/boleto`, data, {
                    headers: { 'X-Idempotency-Key': idem },
                })
                    .then(response => {
                        console.debug('[checkout][postPaymentBol] response', response?.data);
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.error('[checkout][postPaymentBol] error', error?.response?.data || error?.message || error);
                        reject(error.response)
                    });
            });
        },
        postPaymentPixPagBank: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                const url = buildPagbankLinkPath(data, 'pix');
                if (!url) {
                    reject({ data: { message: 'Dados de rota PagBank incompletos.' } });
                    return;
                }
                await axiosInst.post(url, data)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error.response));
            });
        },
        getPagSeguroPublicKey: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                const url = buildPagbankLinkPath(data, 'public-key');
                if (!url) {
                    reject({ data: { message: 'Dados de rota PagBank incompletos.' } });
                    return;
                }
                await axiosInst.get(url)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error.response));
            });
        },
        getPagSeguroInstallments: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                const params = new URLSearchParams();
                if (data?.amount) params.append('amount', data.amount);
                if (data?.bin) params.append('bin', data.bin);
                if (data?.brand) params.append('brand', data.brand);
                if (data?.max_installments) params.append('max_installments', data.max_installments);
                if (data?.max_installments_no_interest) params.append('max_installments_no_interest', data.max_installments_no_interest);
                const query = params.toString();
                const suffix = query ? `?${query}` : '';
                const baseUrl = buildPagbankLinkPath(data, 'fees');
                if (!baseUrl) {
                    reject({ data: { message: 'Dados de rota PagBank incompletos.' } });
                    return;
                }
                await axiosInst.get(`${baseUrl}${suffix}`)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error.response));
            });
        },
        postPaymentCardPagBank: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                const url = buildPagbankLinkPath(data, 'card');
                if (!url) {
                    reject({ data: { message: 'Dados de rota PagBank incompletos.' } });
                    return;
                }
                await axiosInst.post(url, data)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error.response));
            });
        },
        postPaymentBolPagBank: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                const url = buildPagbankLinkPath(data, 'bol');
                if (!url) {
                    reject({ data: { message: 'Dados de rota PagBank incompletos.' } });
                    return;
                }
                await axiosInst.post(url, data)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error.response));
            });
        },

    },
    mutations: {
        UPDATE_LINK_DETAILS: (state, detailLInk) => {

            state.linkCheckoutDetail = detailLInk;
            const accessLink = Cookies.get(detailLInk.uuid);
            if (!accessLink) {
                Cookies.set(detailLInk.uuid, detailLInk.uuid, { expires: 2 })
            }

        },
        UPDATE_STAGE_CHECKOUT: (state, stageCheckout) => {
            state.stageCheckout = stageCheckout;
        },
        UPDATE_USER_CHECKOUT: (state, linkCheckoutUser) => {
            const merged = {
                ...state.linkCheckoutUser,
                ...linkCheckoutUser,
            };
            state.linkCheckoutUser = merged;
            writeToStorage(USER_STORAGE_KEY, merged);
        },
        UPDATE_USER_ADDRESS_CHECKOUT: (state, linkCheckoutUserAddress) => {
            state.linkCheckoutUserAddress = linkCheckoutUserAddress;
            writeToStorage(USER_ADDRESS_STORAGE_KEY, linkCheckoutUserAddress);
        }

    }
}

export default checkout;
